// extracted by mini-css-extract-plugin
export default {"empty":"Exercises_empty__M501n"};